var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width == 0)?_c('img',{class:_vm.export_class,attrs:{"src":require("../../assets/img/icon/namaste.png"),"width":"250"}}):_c('img',{class:_vm.export_class,attrs:{"src":require("../../assets/img/icon/namaste.png"),"width":_vm.width}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac318df","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/DefaultImage.vue
// module id = null
// module chunks = 